import EditReport from './EditReport';

export default EditReport;
